import { makeStyles } from '@mui/styles';
export const dealFreebiesStyles = makeStyles(() => ({
    label: { display: 'inline' },
}), { name: 'Common_DealFreebies' });
//# sourceMappingURL=dealFreebies.styles.js.map